import { Stack } from '@/components/layout'
import NavigationBar from '@/components/NavigationBar'

const screenOptions = { animation: 'none' as const }

export default function OrderLayout() {
  const { t } = useTranslation()

  return (
    <Stack screenOptions={screenOptions}>
      <Stack.Screen name={'index'} />
      <Stack.Screen name={'[action]'} />
      <Stack.Screen name={'jbp'} options={{ header: () => <NavigationBar>{t('orders:fastTrackDetails')}</NavigationBar> }} />
    </Stack>
  )
}
import { useTranslation } from 'react-i18next'
